import React, { useEffect, useState } from 'react';
import { useTranslation } from '../App';
import EnquiryForm from './EnquiryForm';

const Banner = () => {
  const [isActive, setIsActive] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const t = useTranslation();

  const images = [
    '/assets/corousal/IMG_0917.JPG',
    '/assets/corousal/IMG_0918.JPG',
    '/assets/corousal/IMG_0919.JPG',
    '/assets/corousal/IMG_5489.JPG',
    '/assets/corousal/IMG_5520.JPG',
    '/assets/corousal/IMG_6631.JPG',
    '/assets/corousal/IMG_6641-1.JPG',
    '/assets/corousal/IMG_6734-1.JPG'
  ];

  const nextSlide = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsActive(prev => !prev);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="banner" id="home">
      <div className="active">
        <span className={`green ${isActive ? 'myClass' : ''}`}>•</span>
        <span className="active-text">{t.banner.status}</span>
      </div>
      
      <div className="carousel-bg">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index + 1}`}
            className={`carousel-image ${index === currentImage ? 'active' : ''}`}
          />
        ))}
        <button className="carousel-btn prev" onClick={prevSlide}>‹</button>
        <button className="carousel-btn next" onClick={nextSlide}>›</button>
        <div className="carousel-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentImage ? 'active' : ''}`}
              onClick={() => setCurrentImage(index)}
            />
          ))}
        </div>
      </div>

      <div className="banner-content">
        <h1>{t.banner.heading}</h1>
        <div className="cta">
          <p>{t.banner.description}</p>
          <button onClick={() => setShowForm(true)} className="banner-btn">
            {t.banner.button} <img src="/assets/icons/right-arrow.png" width="25px" alt="" />
          </button>
        </div>
      </div>
      <EnquiryForm isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Banner;